// Wrapper de API para gestão de roles e permissões do Hub (PO1-2044).
// Endpoints documentados em PO1-2042 e PO1-2043. Backend: backend_hub.

import api from "./api";

export async function listRoles() {
  const { data } = await api.get("/roles");
  return data;
}

export async function getRole(id) {
  const { data } = await api.get(`/roles/${id}`);
  return data;
}

export async function createRole({ Name, DisplayName, IsDefault }) {
  const { data } = await api.post("/roles", { Name, DisplayName, IsDefault });
  return data;
}

export async function updateRole(id, { Name, DisplayName, IsDefault }) {
  const payload = {};
  if (Name !== undefined) payload.Name = Name;
  if (DisplayName !== undefined) payload.DisplayName = DisplayName;
  if (IsDefault !== undefined) payload.IsDefault = IsDefault;
  const { data } = await api.put(`/roles/${id}`, payload);
  return data;
}

export async function deleteRole(id) {
  const { data } = await api.delete(`/roles/${id}`);
  return data;
}

export async function getRolePermissions(id) {
  const { data } = await api.get(`/roles/${id}/permissions`);
  return data;
}

export async function updateRolePermissions(id, permissionNames) {
  const { data } = await api.put(`/roles/${id}/permissions`, { permissionNames });
  return data;
}

export async function getPermissionsTree(multiTenancySide) {
  const params = multiTenancySide ? { multiTenancySide } : undefined;
  const { data } = await api.get("/permissions/tree", { params });
  return data;
}

export async function getMyPermissions() {
  const { data } = await api.get("/permissions/me");
  return data;
}
